import { render } from "./FloatingPhoneButton.vue?vue&type=template&id=5e4223d2&scoped=true"
import script from "./FloatingPhoneButton.vue?vue&type=script&lang=js"
export * from "./FloatingPhoneButton.vue?vue&type=script&lang=js"

import "./FloatingPhoneButton.vue?vue&type=style&index=0&id=5e4223d2&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4223d2"]])

export default __exports__